// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NicheChartsTab {
  margin-bottom: 64px;
}
.NicheChartsTab .NicheChartsTab-nicheContent {
  margin-top: 32px;
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-column-gap: 20px;
  column-gap: 20px;
}
.NicheChartsTab .NicheChartsTab-contextDescription {
  margin-top: 20px;
}
.NicheChartsTab .NicheChartsTab-resetButton {
  font-size: 14px;
  color: var(--color_neutral_800);
}
.NicheChartsTab .NicheChartsTab-charts {
  display: flex;
  flex-direction: column;
}
.NicheChartsTab .NicheChartsTab-emptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.NicheChartsTab .NicheChartsTab-emptyState p,
.NicheChartsTab .NicheChartsTab-emptyState span {
  font-size: 18px;
  color: var(--color_neutral_800);
  text-align: center;
}
.NicheChartsTab .NicheChartsTab-nicheListTitleRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.NicheChartsTab .NicheChartsTab-nicheListTitleRow h3 {
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
}

.NicheChartsTab-empty {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
}
.NicheChartsTab-empty .NicheChartsTab-emptyContextsText {
  margin-top: 8px;
  font-size: 18px;
  color: var(--color_neutral_800);
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/modules/niche/niche-charts-tab/niche-charts-tab.styles.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AACE;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;EAAA,gBAAA;AACJ;AAEE;EACE,gBAAA;AAAJ;AAGE;EACE,eAAA;EACA,+BAAA;AADJ;AAIE;EACE,aAAA;EACA,sBAAA;AAFJ;AAKE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAHJ;AAKI;;EAEE,eAAA;EACA,+BAAA;EACA,kBAAA;AAHN;AAOE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AALJ;AAOI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AALN;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAPF;AASE;EACE,eAAA;EACA,eAAA;EACA,+BAAA;EACA,kBAAA;AAPJ","sourcesContent":[".NicheChartsTab {\n  margin-bottom: 64px;\n\n  .NicheChartsTab-nicheContent {\n    margin-top: 32px;\n    display: grid;\n    grid-template-columns: 1fr 3fr;\n    column-gap: 20px;\n  }\n\n  .NicheChartsTab-contextDescription {\n    margin-top: 20px;\n  }\n\n  .NicheChartsTab-resetButton {\n    font-size: 14px;\n    color: var(--color_neutral_800);\n  }\n\n  .NicheChartsTab-charts {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .NicheChartsTab-emptyState {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    margin-top: 20px;\n\n    p,\n    span {\n      font-size: 18px;\n      color: var(--color_neutral_800);\n      text-align: center;\n    }\n  }\n\n  .NicheChartsTab-nicheListTitleRow {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n\n    h3 {\n      font-size: 24px;\n      font-style: normal;\n      font-weight: 600;\n    }\n  }\n}\n\n.NicheChartsTab-empty {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  margin-top: 32px;\n\n  .NicheChartsTab-emptyContextsText {\n    margin-top: 8px;\n    font-size: 18px;\n    color: var(--color_neutral_800);\n    text-align: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
